module.exports = __webpack_public_path__ + "static/media/logo_atone.f7aa1522.png";